import Vue from 'vue'
import VueRouter from 'vue-router'
import layout from '@/layout/layout.vue'
import layout1 from '@/layout/layout1.vue'

Vue.use(VueRouter)

//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = [
  /* {
      path: '',
      redirect: '/pc_index'
    }, */
  {
    path: '/',
    name: '首页判断',
    component: layout,
    redirect: '/',

    children: [{
      path: '/',
      name: '合作招商',
      component: () => import('@/views/index.vue')

    }, ]
  },
  {
    path: '/pc_index',
    name: '布局页',
    component: layout,
    // redirect: '/',
    children: [
      // {
      //   path: '/',
      //   name: '首页',
      //   component: () => import('@/views/pc/home.vue')
      // },

      {
        path: '/cooperation',
        name: '合作招商',
        component: () => import('@/views/pc/cooperation.vue')
      },
      {
        path: '/zscomputer',
        name: '招生计算器',
        component: () => import('@/views/pc/zscomputer.vue')
      },
      {
        path: '/curriculum',
        name: '课程共建',
        component: () => import('@/views/pc/curriculum.vue')
      },
      {
        path: '/sys',
        name: '系统',
        component: () => import('@/views/pc/sys.vue')
      },
      {
        path: '/dgnstyle',
        name: '多功能学习平台',
        component: () => import('@/views/pc/dgnstyle.vue')
      },
      {
        path: '/jjfa',
        name: '解决方案',
        component: () => import('@/views/pc/jjfa.vue')
      },

      {
        path: '/zcfw',
        name: '支持服务',
        component: () => import('@/views/pc/zcfw.vue')
      },
      {
        path: '/mfsy',
        name: '免费试用',
        component: () => import('@/views/pc/mfsy.vue')
      },
      {
        path: '/productSystem',
        name: '产品与服务(网校系统)',
        component: () => import('@/views/pc/productSystem.vue')
      },
      {
        path: '/productSystems',
        name: '产品与服务(网校系统)(免费试用)',
        component: () => import('@/views/pc/productSystems.vue')
      },
      {
        path: '/aboutIntroduce',
        name: '关于我们(公司简介)',
        component: () => import('@/views/pc/aboutIntroduce.vue')
      },
      {
        path: '/aboutJoin',
        name: '关于我们(加入我们)',
        component: () => import('@/views/pc/aboutJoin.vue')
      },
      {
        path: '/aboutNew',
        name: '关于我们(新闻动态)',
        component: () => import('@/views/pc/aboutNew.vue')
      },
      {
        path: '/aboutNewXq',
        name: '关于我们(新闻动态详情)',
        component: () => import('@/views/pc/aboutNewXq.vue')
      }
    ]
  },
  {
    path: '/m_index',
    name: '布局页',
    component: layout1,
    // redirect: '/',
    children: [
      // {
      //   path: '/',
      //   name: '首页',
      //   component: () => import('@/views/mobile/home.vue')
      // },
      {
        path: '/mfsy1',
        name: '免费试用',
        component: () => import('@/views/mobile/mfsy.vue')
      },
      {
        path: '/cooperation1',
        name: '合作招商',
        component: () => import('@/views/mobile/cooperation.vue')
      },
      {
        path: '/sys1',
        name: '系统',
        component: () => import('@/views/mobile/sys.vue')
      },
      {
        path: '/zcfw1',
        name: '支持服务',
        component: () => import('@/views/mobile/zcfw.vue')
      },
      {
        path: '/dgnstyle1',
        name: '多功能学习平台',
        component: () => import('@/views/mobile/dgnstyle.vue')
      },
      {
        path: '/curriculum1',
        name: '课程共建',
        component: () => import('@/views/mobile/curriculum.vue')
      },
      {
        path: '/productSystem1',
        name: '产品与服务(网校系统)',
        component: () => import('@/views/mobile/productSystem.vue')
      },
      {
        path: '/productSystems1',
        name: '产品与服务(网校系统)(免费试用)',
        component: () => import('@/views/mobile/productSystems.vue')
      },
      {
        path: '/aboutIntroduce1',
        name: '关于我们(公司简介)',
        component: () => import('@/views/mobile/aboutIntroduce.vue')
      },
      {
        path: '/aboutJoin1',
        name: '关于我们(加入我们)',
        component: () => import('@/views/mobile/aboutJoin.vue')
      },
      {
        path: '/aboutNew1',
        name: '关于我们(新闻动态)',
        component: () => import('@/views/mobile/aboutNew.vue')
      },
      {
        path: '/aboutNewXq1',
        name: '关于我们(新闻动态详情)',
        component: () => import('@/views/mobile/aboutNewXq.vue')
      },
      {
        path: '/zhiweimsg',
        name: '职位详情',
        component: () => import('@/views/mobile/zhiweimsg.vue')
      }
    ]
  },
  {
    path: '/jupc/baidu/1-jn-ty',
    name: '专题页',
    component: () => import('@/views/pc/jupc/baidu/1-jn-ty.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  // scrollBehavior (to, from, savedPosition) {
  //   if (savedPosition) {
  //     return savedPosition
  //   } else {
  //     return { x: 0, y: 0 }
  //   }
  // },
  routes
})

export default router